import { createAction } from '../utils';
import * as actionTypes from './user.actionTypes';

export const getUser = () => createAction(actionTypes.GET_USER.REQUEST, {});

export const updateUser = data =>
  createAction(actionTypes.UPDATE_USER.REQUEST, data);
